import React, { ComponentProps } from "react";

function TrophyIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M2.67725 5.13456C2.67725 8.83006 4.50501 11.2191 8.1204 12.3345C8.69823 13.0607 9.35853 13.649 10.0088 14.0609V17.8352H8.57961C7.27936 17.8352 6.5722 18.6036 6.5722 19.8443V21.3886C6.5722 21.866 6.94567 22.2081 7.4007 22.2081H16.1377C16.5927 22.2081 16.9662 21.866 16.9662 21.3886V19.8443C16.9662 18.6036 16.2516 17.8352 14.9514 17.8352H13.5312V14.0609C14.1815 13.649 14.8402 13.0607 15.4106 12.3345C19.0351 11.2191 20.8612 8.83006 20.8612 5.13456C20.8612 4.12549 20.2145 3.49934 19.1642 3.49934H17.4382C17.2504 2.56312 16.5555 2 15.4271 2H8.11132C6.99198 2 6.28809 2.55567 6.1019 3.49934H4.37585C3.32392 3.49934 2.67725 4.12549 2.67725 5.13456ZM4.19348 5.34345C4.19348 5.20303 4.29756 5.0915 4.44706 5.0915H6.02706V6.77032C6.02706 8.02916 6.34132 9.20608 6.83577 10.2382C5.10591 9.30653 4.19348 7.66713 4.19348 5.34345ZM16.6968 10.2382C17.1971 9.20608 17.5113 8.02916 17.5113 6.77032V5.0915H19.093C19.2408 5.0915 19.3449 5.20303 19.3449 5.34345C19.3449 7.66713 18.4325 9.30491 16.6968 10.2382Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default TrophyIcon;
